import PropTypes from 'prop-types';
import React, {Component} from 'react';

export default class ShareTokenListItem extends Component {
    static propTypes = {
        token: PropTypes.object,
        onDelete: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            access_level: props.token.access_level
        };
    }

    handleAccessLevelChange = e => {
        const access_level = e.target.value;
        this.setState({access_level}, () => {
            this.props.onChange({access_level, id: this.props.token.id});
        });
    };

    handleDeleteClick = e => {
        e.preventDefault();

        this.props.onDelete();
    };

    render() {
        const {email} = this.props.token;

        return (
            <div className="list-share-link">
                <div>{email}</div>
                <a href="#" onClick={this.handleDeleteClick}>
                    <i className="fa fa-trash" />
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/share_content_modal/share_token_list_item.js